import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('WizardSpecificPageLinkBottomContent', (theme) => ({
  root: {
    marginTop: theme.spacing(1.5), // Ensures even padding between main action button and above content
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      backgroundColor: 'initial',
    },
  },
}));

const WizardSpecificPageLinkBottomContent = ({ prompt, onClick }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Button1
      className={classes.root}
      color={'primary'}
      variant={'text'}
      onClick={onClick}
      test={'specific-page-link-button'}
    >
      {prompt}
    </Button1>
  );
};

WizardSpecificPageLinkBottomContent.propTypes = {
  onClick: PropTypes.func.isRequired,
  prompt: PropTypes.string.isRequired,
};

export default WizardSpecificPageLinkBottomContent;
